import React from 'react';
import IndustryPageTemplate from './IndustryPageTemplate';

const pageData = {
  seo: {
    title: 'Custom Restaurant Ordering Apps & POS Software | RojrzTech',
    description: 'Empower your restaurant or cafe with custom commission-free online food ordering systems, interactive digital menus, and table reservation software.',
  },
  hero: {
    badge: 'RESTAURANT & CAFE',
    slides: [
      {
        heading: { pre: 'Commission-Free', gold: 'Restaurant Ordering', post: 'Systems' },
        subheading: 'Stop losing 30% to third-party delivery apps. We build custom online food ordering systems, contactless QR menus, and table booking tools.',
        pills: ['Direct Ordering', 'QR Code Menu', 'Kitchen POS Sync', 'Table Booking', 'Stripe Payments'],
        image: '/resturant1.jpeg',
      },
      {
        heading: { pre: 'Contactless QR Menus &', gold: 'Table ordering' },
        subheading: 'Let dine-in customers scan QR codes to browse your digital menu, customize orders, and pay directly from their tables without waiting.',
        pills: ['QR Code Scan', 'Dine-In Cart', 'Table Assignment', 'Payment Checkout', 'Kitchen Display'],
        image: '/resturant.jpeg',
      },
      {
        heading: { pre: 'Live Kitchen Display &', gold: 'Delivery Dispatch' },
        subheading: 'Sync online orders directly with kitchen screens and dispatch drivers with live delivery tracking alerts and automated eta notifications.',
        pills: ['Kitchen Screen App', 'Driver Map Tracker', 'Automated ETA', 'POS Integration', 'Sales Logs'],
        image: '/resturant1.jpeg',
      },
    ],
  },
  showcase: {
    phoneTitle: 'DIGITAL MENU APP',
    phoneSubtitle: 'Select dishes, customize options, and order instantly.',
    tags: [
      { title: 'Commission-Free Orders', desc: 'Accept direct delivery and pickup orders without paying third-party commissions.' },
      { title: 'Local Search Lead Capture', desc: 'Rank top-3 locally for restaurant searches like "food delivery near me".' },
      { title: 'Table Reservation System', desc: 'Let customers reserve tables online, reducing phone reservation admin time.' },
      { title: 'Contactless QR Menu', desc: 'Dine-in guests can scan, order, and pay directly from their table.' },
      { title: 'Kitchen POS Sync API', desc: 'Transmit online orders straight to your kitchen ticket printer or display.' },
      { title: 'Dynamic Promo Coupons', desc: 'Launch customer loyalty rewards, discount codes, and menu promotions.' },
    ],
  },
  videoSection: {
    title: 'POS Kitchen Screen Demo',
    subtitle: 'See how our digital ordering platform syncs customer orders directly to active kitchen displays.',
    frameLabel: 'RESTAURANT KITCHEN DISPATCH CONSOLE',
  },
  cards: {
    title: 'Custom Solutions Tailored for Food & Beverage',
    subtitle: 'We build fast, secure ordering systems that streamline restaurant operations and boost direct customer relationships.',
    items: [
      {
        icon: '🍔',
        title: 'Direct Ordering Websites',
        description: 'An interactive menu ordering website where customers can customize dishes, select delivery/pickup times, and check out.',
      },
      {
        icon: '🛒',
        title: 'QR Code Menu Systems',
        description: 'Eliminate printed menus. Dine-in tables get dedicated QR codes linked to an interactive ordering web application.',
      },
      {
        icon: '⚡',
        title: 'Kitchen Display Application',
        description: 'Provide kitchen staff with a dedicated tablet app displaying incoming orders, cooking modifiers, and pickup details.',
      },
    ],
  },
  features: {
    title: 'All-In-One Restaurant App Features',
    subtitle: 'Optimize kitchen efficiency, increase average order values, and drive local loyalty with custom dining features.',
    items: [
      'Interactive Digital Menu',
      'Table QR Code Ordering',
      'Direct Stripe Checkout',
      'Table Booking Widgets',
      'Dish Customization Logic',
      'Kitchen Ticket Printing',
      'Order Status Tracker',
      'Delivery Driver GPS Map',
      'Customer Loyalty Rewards',
      'Dine-in/Delivery Settings',
      'Busy Hour Time Limits',
      'Menu Item Analytics',
    ],
  },
};

const Restaurant = () => {
  return <IndustryPageTemplate pageData={pageData} />;
};

export default Restaurant;
